import { render, staticRenderFns } from "./VendorAllocatedTable.vue?vue&type=template&id=62a16bf0&"
import script from "./VendorAllocatedTable.vue?vue&type=script&lang=js&"
export * from "./VendorAllocatedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62a16bf0')) {
      api.createRecord('62a16bf0', component.options)
    } else {
      api.reload('62a16bf0', component.options)
    }
    module.hot.accept("./VendorAllocatedTable.vue?vue&type=template&id=62a16bf0&", function () {
      api.rerender('62a16bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vendors/VendorAllocatedTable.vue"
export default component.exports